import React, { Component } from 'react';
import { Box, Typography, Link } from '@mui/material';
import ChartToolbar from './chart_toolbar';

class ChartHeader extends Component {
    
    handleOpenPicker = () => {
        this.props.onChartPicker();
    }

    getDisplayOutput = () => {
        // Hide toolbar for table charts
        if (this.props.chartType === 'badge_basic_table') {
            return null;
        }

        if (this.props.showToolbar === true){
            return (
                <React.Fragment>
                    <ChartToolbar onPickerOpen={this.handleOpenPicker} />
                </React.Fragment>
            )
        } else {
            return null;
        }
    }
    
    render() { 
        return ( 
            <Box sx={{ py: 1, px: 3, display: 'flex', alignItems: 'center', minHeight: '48px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Typography 
                        component={Link}
                        href={`/chart/${this.props.chartId}${this.props.dashboardId ? `?dashboardId=${this.props.dashboardId}` : ''}`}
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '1.2rem',
                            '&:hover': {
                                color: 'text.primary'
                            }
                        }}
                    >
                        {this.props.displayName}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {this.getDisplayOutput()}
                    </Box>
                </Box>
            </Box>
         );
    }
}
 
export default ChartHeader;